import {Deserializable} from "./deserializable.model";

export class AppRouteABillingItem {

    
    billing_task_name: string;
    myob_tax_code_id: any;
    myob_account_code_id: any;
    billing_task_description: string;
    brand_type_id: number;
    job_type_id: number;
    billing_task_fee: number;

    app_route_billing_item_id?;
    subject_id?;
    subject_number?;
    invoice_status?;
    invoice_id?;
    invoice_number?;
    brand_id?;
    qty?;
    unit_price?;
    total?;
    is_bulk?;
    tax?;
    app_route_id?;

  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): AppRouteABillingItem {
    Object.assign(this, input);

    return this;
  }

  /*
billing_task_id
billing_task_name
tax_code_id
myob_account_code_id
billing_task_description
brand_type_id
job_type_id
billing_task_fee
  */


}


/*
CREATE TABLE `app_route_billing_items` (
  `app_route_billing_item_id` int(11) NOT NULL AUTO_INCREMENT,
  `billing_task_name` varchar(255) DEFAULT NULL,
  `myob_tax_code_id` int(11) DEFAULT NULL,
  `myob_account_code_id` int(11) DEFAULT NULL,
  `billing_task_description` varchar(11) DEFAULT NULL,
  `billing_task_fee` decimal(11,2) DEFAULT NULL,
  `billing_task_id` int(11) DEFAULT NULL,
  `subject_id` int(11) DEFAULT NULL,
  `subject_number` varchar(255) DEFAULT NULL,
  `job_id` int(11) DEFAULT NULL,
  `job_number` varchar(255) DEFAULT NULL,
  `invoice_status` varchar(255) DEFAULT 'NOT-INVOICED',
  `invoice_id` int(11) DEFAULT NULL,
  `invoice_number` varchar(255) DEFAULT NULL,
  `brand_id` int(11) DEFAULT NULL,
  `qty` int(11) DEFAULT '1',
  `unit_price` decimal(11,2) DEFAULT NULL,
  `total` decimal(11,2) DEFAULT NULL,
  `is_bulk` int(11) DEFAULT NULL,
  `tax` decimal(11,3) DEFAULT NULL,
  `app_route_id` int(11) DEFAULT NULL,
  PRIMARY KEY (`app_route_billing_item_id`)
) ENGINE=InnoDB AUTO_INCREMENT=4 DEFAULT CHARSET=utf8

*/